module.exports = __webpack_public_path__ + "static/media/w_bishop.babb8b9e.png";